// 定义树节点
export interface TreeNode {
  children?: TreeNode[];
  [propsName: string]: unknown;
}

// 校验函数接受一个树节点，返回布尔值
type ValidationFunction = (node: TreeNode) => boolean;

/**
 * 校验tree是否没有节点都符合条件
 * @param tree
 * @param validateNode
 * @returns
 */
// 校验整个树是否满足条件
export function validateTree<T>(
  tree: TreeNode,
  validateNode: ValidationFunction
): boolean {
  // 校验当前节点
  if (!validateNode(tree)) {
    return false;
  }

  // 递归校验子节点
  if (tree.children) {
    for (const child of tree.children) {
      if (!validateTree(child, validateNode)) {
        return false;
      }
    }
  }

  // 如果所有节点都满足条件，则返回true
  return true;
}

export function filterTreeByKey(
  tree: TreeNode[],
  filterFun: (node: TreeNode) => boolean
): TreeNode[] {
  function filterNode(node: TreeNode): TreeNode | null {
    // 过滤子节点
    const filteredChildren = node.children
      ?.map(filterNode)
      .filter((child) => child !== null) as TreeNode[];

    // 如果当前节点的key匹配，或者有任何子节点被保留下来，则保留当前节点
    if (filterFun(node) || (filteredChildren && filteredChildren.length > 0)) {
      return { ...node, children: filteredChildren };
    }

    // 否则，丢弃当前节点
    return null;
  }

  // 对每个顶级节点进行过滤
  return tree.map(filterNode).filter((node) => node !== null) as TreeNode[];
}
